// extracted by mini-css-extract-plugin
export var link = "_rc-0";